import { useNavigate } from 'react-router-dom';
import { useCustomerContext } from '../../../utils/customerContext';
import './customer.css';
import './components/customer.components.css'
import { useEffect, useState } from 'react';
import CustomerCard from './components/customerCard';
import CustomSelect from '../../../components/customSelect/customSelect';
import Input from '../../../components/input/input';
import Button from '../../../components/button/button';

function Customer() {
    const navigate = useNavigate();
    const { fetchCustomers, customers, listStatus, searchCustomer, searchedCustomer, customerHasMore } = useCustomerContext();
    const [selectedStatusObj, setSelectedStatusObj] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchCustomers(true);
    }, [fetchCustomers]);
    
    useEffect(() => {
        searchCustomer(searchTerm);
    }, [searchTerm, searchCustomer]);

    const selectedStatusValue = selectedStatusObj ? selectedStatusObj.name : '';

    const baseCustomers = searchTerm ? searchedCustomer : customers;

    const displayedCustomers = selectedStatusValue
        ? baseCustomers.filter(c => (c.status || '').toString() === selectedStatusValue)
        : baseCustomers;

    const formattedStatusList = listStatus.map((s, index) => ({
        id: index.toString(),
        name: s
    }));

    const handleNavigate = (id) => {
        navigate(`/dashboard/customer/${id}`);
    }

    return (
        <div className='pageContainer'>
            <div className='customerHeader'>
                <h1>Kundenübersicht</h1>
                <Button buttonValue='Neuer Kunde' onClick={() => navigate('/dashboard/customer/new')} />
            </div>

            <div className='customerControls'>
                <Input
                    inputValue={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    inputType='text'
                    inputId='searchCustomer'
                    inputName='searchCustomer'
                    width='100%'
                    borderColor='black'
                    placeholder='Kunde suchen...'
                />

                <CustomSelect 
                    items={formattedStatusList} 
                    selected={selectedStatusObj} 
                    setSelected={setSelectedStatusObj} 
                    displayKey="name" 
                    placeholder='Kundenstatus suchen...'
                    search={false}
                />
            </div>

            <div className='allCustomersContainer'>
                <div className='allCustomersCardContainer'>
                    {displayedCustomers.length > 0 ? (
                        displayedCustomers.map((customer) => (
                            <CustomerCard
                                key={customer._id}
                                id={customer._id}
                                prename={customer.prename}
                                name={customer.name}
                                address={customer.address}
                                postCode={customer.postCode}
                                town={customer.town}
                                customerNumber={customer.customerNumber}
                                status={customer.status}
                                onClick={() => handleNavigate(customer._id)}
                            />
                        ))
                    ) : (
                        <p className="no-results-text">Keine Kunden gefunden.</p>
                    )}
                </div>

                {customerHasMore && !searchTerm && (
                    <Button
                        buttonValue='Mehr laden'
                        onClick={() => fetchCustomers(false)}
                    />
                )}

                {!customerHasMore && customers.length > 0 && (
                    <p style={{ textAlign: 'center' }}>Alle Kunden geladen</p>
                )}
            </div>
        </div>
    );
}

export default Customer;